import { requestHandler } from '../../api';

export const updateArrearRate = async (dispatch: any, data: any) => {
  const response = await requestHandler({
    method: 'patch',
    url: 'internal/document/arrearRate',
    data,
    dispatch,
  });
  if (response) return response.data;
};
